import { FC, MouseEventHandler } from 'react'
import { useHistory } from 'react-router-dom'

import CONFIG from '../../../config'
import { Title, Text, Button, Icon } from '../UI'

type AdminAdsFormSuccessProps = {
  className?: string,
  title?: string,
  message?: string,
  buttonText?: string,
  onClick?: MouseEventHandler<HTMLButtonElement>
}

const AdminAdsFormSuccess:FC<AdminAdsFormSuccessProps> = ({ 
  className = '', 
  title = '¡Creación exitosa!', 
  message = 'El anuncio se ha creado correctamente', 
  buttonText = '', 
  onClick 
}) => {
  const history = useHistory()

  return (
    <div className={`text-center ${className}`}>
      <Icon name="modal-success" />
      <Title component="h4" size="20" weight="bold" lineHeight="4" className="mt-30">{title}</Title>
      {message && <Text size="14" className="mt-20">{message}</Text>}
      {buttonText && <Button className="mt-30" onClick={onClick}>{buttonText}</Button>}
      <Button className="mt-20" onClick={() => history.push(CONFIG.ROUTES.ADMIN.ADS.HOME)}>VOLVER AL ADMINISTRADOR</Button>
    </div>
  )
}

export { AdminAdsFormSuccess }